"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../../../shared");

var Button_meta_1 = require("./Button.meta");

var Button =
/** @class */
function (_super) {
  __extends(Button, _super);

  function Button(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Button_meta_1.BUTTON_CATEGORY_KEY;
    _this.componentKey = Button_meta_1.BUTTON_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Button.prototype, "parentComponentKey", {
    get: function get() {
      return Button_meta_1.BUTTON_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });

  Button.prototype.componentDidMount = function () {
    this.setFocus();
  };

  Button.prototype.componentDidUpdate = function () {
    this.setFocus();
  };

  Button.prototype.setFocus = function () {
    var isFocused = this.props.isFocused;

    if (isFocused && this.buttonRef) {
      this.buttonRef.current.focus();
    }
  };

  Button.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        otherProps = __rest(_a, ["children"]);

    this.buttonRef = react_1.default.createRef();
    return react_1.default.createElement("div", __assign({
      ref: this.buttonRef,
      tabIndex: 0
    }, otherProps, {
      role: "button"
    }), children);
  };

  Button = __decorate([mobx_react_1.observer], Button);
  return Button;
}(shared_1.ComponentBase);

exports.Button = Button;
exports.default = shared_1.InjectedStyledComponent(Button, Button_meta_1.BUTTON_CATEGORY_KEY, Button_meta_1.BUTTON_PARENT_COMPONENT_KEY, [Button_meta_1.BUTTON_COMPONENT_KEY]);